import React, { ChangeEvent, useCallback } from 'react';

import './radio-group.css';

export type RadioData = {
  text: string;
  value?: string;
  checked?: boolean;
  name?: string;
}

export type RadioGroupProps = {
  radios: RadioData[];
  onSelect?: (text: string) => void;
  disabled?: boolean;
  name?: string;
  // Two columns on wide screens (the last odd item spans both).
  columns?: 1 | 2;
  // What to show in the badge on the left of each option:
  // 'letter' = A, B, C...; 'initial' = first letter of the text (player names).
  badge?: 'letter' | 'initial' | 'none';
};

const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const RadioGroup = ({
  radios,
  onSelect,
  disabled,
  name,
  columns = 1,
  badge = 'letter'
}: RadioGroupProps) => {
  const onChange = useCallback((evt: ChangeEvent<HTMLInputElement>) => {
    onSelect && onSelect((evt.target as any).value);
  }, [onSelect]);

  const groupName = name ?? 'radios';

  return (
    <div className={'optionList' + (columns === 2 ? ' twoCol' : '')}>
      {radios.map((r, i) => {
        const id = `radio_${groupName}_${i}`;
        return (
          <div key={r.text + i} className='radiobtn'>
            <input
              disabled={!!disabled}
              onChange={onChange}
              id={id}
              type='radio'
              name={r.name ?? groupName}
              checked={!!r.checked}
              value={r.value ?? r.text}
            />
            <label htmlFor={id}>
              {badge !== 'none' && (
                <span className={'optionBadge' + (badge === 'initial' ? ' avatar' : '')}>
                  {badge === 'letter' ? LETTERS[i % LETTERS.length] : r.text.trim().charAt(0)}
                </span>
              )}
              <span className='optionText'>{r.text}</span>
              <span className='optionCheck' aria-hidden='true'></span>
            </label>
          </div>
        );
      })}
    </div>
  );
};
